import React, { forwardRef } from 'react';

import { Button, ButtonProps, ButtonSize, ButtonVariant } from '../button';

export interface IconButtonProps
  extends Omit<ButtonProps, 'iconOnly' | 'startIcon' | 'endIcon' | 'fullWidth' | 'size' | 'variant' | 'aria-label'> {
  /** What the button does, read by screen readers and shown as the tooltip. */
  label: string;
  size?: ButtonSize;
  variant?: ButtonVariant;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ label, size = 'sm', variant = 'ghost', type = 'button', children, ...rest }, ref) => (
    <Button ref={ref} iconOnly size={size} variant={variant} type={type} aria-label={label} title={label} {...rest}>
      {children}
    </Button>
  ),
);

IconButton.displayName = 'IconButton';
